import { render, staticRenderFns } from "./UserCoupon.vue?vue&type=template&id=35fd4dc6&scoped=true&"
import script from "./UserCoupon.vue?vue&type=script&lang=js&"
export * from "./UserCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd4dc6",
  null
  
)

component.options.__file = "UserCoupon.vue"
export default component.exports